import React from 'react';

export default ({ networks, screenReaderText }) => (
    <div className="c-profile__icon-list">
        {networks && networks.map((network, i) => network.url && (
            <a
                href={network.url}
                className="c-profile__icon"
                data-click-type="social-network"
                target="_blank"
                data-network-name={network.type}
                key={i}
            >
                <span className={`fa ${network.icon}`} aria-hidden="true"/>
                <span className="sr-only">{network.type} {screenReaderText}</span>
            </a>
        ))}
    </div>
);



// WEBPACK FOOTER //
// ./components/profile/profile_social_icons.jsx